import { render, staticRenderFns } from "./TeamTab.vue?vue&type=template&id=1f671d0c&scoped=true&"
import script from "./TeamTab.vue?vue&type=script&lang=js&"
export * from "./TeamTab.vue?vue&type=script&lang=js&"
import style0 from "./TeamTab.vue?vue&type=style&index=0&id=1f671d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f671d0c",
  null
  
)

export default component.exports